import styled from 'styled-components';
import { flexbox } from '../../styles/helpers/flexbox';

const ModalButtons = styled.div`
    ${flexbox()}
        & > div {
            margin: 5px;
        }
    `;

export default ModalButtons;



// WEBPACK FOOTER //
// ./app/components/with-auth/styled.js